import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAdvancedFilterOptions } from '../models/dto/case-search/base-advanced-filter-options.model';
import { BaseFilterOptions } from '../models/dto/case-search/base-filter-options.model';
import { SearchResult } from './../models/dto/search-result.model';

@Injectable()
export class BaseHubService<AdvancedFilters extends BaseAdvancedFilterOptions, Item, SR extends SearchResult<Item>> {
  protected searchEndPoint: string;
  protected savedSearchEndPoint: string;
  protected deleteEndPoint: string;
  constructor(protected httpClient: HttpClient) {}

  public search(filter: BaseFilterOptions<AdvancedFilters>): Observable<SR> {
    return this.httpClient
      .post(this.searchEndPoint, filter)
      .pipe(map((data) => new SearchResult<Item>().deserialize(data) as SR));
  }

  public getSavedSearches(): Observable<Array<BaseFilterOptions<AdvancedFilters>>> {
    return this.httpClient
      .get(this.savedSearchEndPoint)
      .pipe(
        map((data: Array<any>) =>
          data.map((baseFilters) => new BaseFilterOptions<AdvancedFilters>().deserialize(baseFilters))
        )
      );
  }

  public deleteSavedSearch(name: string): Observable<any> {
    const params = new HttpParams().set('name', name);

    return this.httpClient.delete(this.deleteEndPoint, { params });
  }
}
